export const TrackingStatus = {
  NOT_FOUND: "Unknown",
  IN_TRANSIT: "In transit",
  LOST: "Lost",
  DELIVERED: "Delivered",
};